module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/components/empty.html
// module id = 1197
// module chunks = 1